import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { TournamentsService } from './../tournaments/services/tournaments.service';
declare let $;
declare let SetLanguage: any;
@Component({
    selector: 'comp_explanation_modal',
    templateUrl: './explanation_modal.html',
})
export class Explanation implements OnInit {
    constructor(public tournamentsService: TournamentsService) {}
    init: boolean;
    ngOnInit() {
        if (this.init) return;
        this.init = true;
    }
    ExitExplanationModal() {
        $('.ui.modal.explanation_modal_class').modal('hide');
    }
    ExplanationdownScroll() {
        $('.explanation_list').animate(
            {
                scrollTop: '+=100',
            },
            300,
            'swing',
        );
    }
    ExplanationupScroll() {
        $('.explanation_list').animate(
            {
                scrollTop: '-=100',
            },
            300,
            'swing',
        );
    }
}
